<template>
  <div>
    <img
      v-if="useImage"
      class="image"
      :src="src"
      :alt="alternativeText"
      @error="handleImageError"
    >
    <UkaskoGrayIcon v-else class="image" />
  </div>
</template>

<script>
import { UkaskoGrayIcon } from '@/shared/ui/icons';

export default {
  props: {
    src: {
      type: String,
      default: '',
    },
    alternativeText: {
      type: String,
      default: '',
    },
  },
  components: { UkaskoGrayIcon },
  data() {
    return {
      useImage: !!this.src,
    };
  },
  methods: {
    handleImageError() {
      this.useImage = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.image {
  max-height: 150px;
  margin-right: 12px;
}
</style>
